import axios from "axios";
import {v4 as uuidv4} from 'uuid';
import {postDataMetabase} from "../../shared/networkUtil";
import {isMobile} from 'react-device-detect';


export const sendAnalytics = (eventTag) => {
    return dispatch => {
        let userId = localStorage.getItem("userId");
        if (!userId) {
            userId = "";
        }
        let email = localStorage.getItem("email");
        if (!email) {
            email = "";
        }
        let source = localStorage.getItem("source");
        let utmSource = localStorage.getItem("utm_source");
        if (!source) {
            source = ""
        }
        if (utmSource) {
            source = utmSource
        }

        const platform = isMobile ? "mobile" : "desktop";
        let ip = localStorage.getItem("ip");
        let sessionId = localStorage.getItem("jbSessionId");
        if (sessionId === null) {
            sessionId = uuidv4();
            localStorage.setItem("jbSessionId", sessionId);
        }

        const browser = localStorage.getItem("browser");
        const operatingSystem = localStorage.getItem("operatingSystem");
        const device = localStorage.getItem("device");
        const deviceCategory = localStorage.getItem("deviceCategory");
        const requestData = {
            email: email,
            userId: userId,
            platform: platform,
            source: source,
            eventTag: eventTag,
            ip: ip,
            referrer: document.referrer,
            sessionId: sessionId,
            domain: document.URL,
            browser: browser ? browser : null,
            operatingSystem: operatingSystem ? operatingSystem : null,
            device: device ? device : null,
            deviceCategory: deviceCategory ? deviceCategory : null,
        };
        if (ip === null) {
            axios.get("https://ipapi.co/json/").then(result => {
                localStorage.setItem("ip", result.data["ip"]);
                localStorage.setItem("country", result.data["country"]);
                ip = result.data["ip"];
                requestData["ip"] = ip;
                sendAnalyticsToMetabase(requestData, eventTag);
            }).catch(err => {
                console.warn("Could not load ip");
                ip = "";
                requestData["ip"] = ip;
                sendAnalyticsToMetabase(requestData, eventTag);
            })
        } else {
            sendAnalyticsToMetabase(requestData, eventTag);
        }

    };
};

const sendAnalyticsToMetabase = (requestData, eventTag) => {
    postDataMetabase(
        "/analytics/event",
        requestData,
        response => {
            console.log("event sent", eventTag)
        },
        err => {
            console.warn("sending analytics failed")
        });
};
